<script lang="ts" setup>
  import { useThemeStore } from '@/stores/theme';
  const themeStore = useThemeStore();
</script>

<template>
  <div
    v-if="themeStore.isLight"
    role="status"
    class="space-y-2.5 animate-pulse max-w-lg">
    <div class="flex items-center w-full space-x-2">
      <div class="h-2.5 bg-gray-200 rounded-full w-32" />
      <div class="h-2.5 bg-gray-300 rounded-full w-24" />
      <div class="h-2.5 bg-gray-300 rounded-full w-full" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[480px]">
      <div class="h-2.5 bg-gray-200 rounded-full w-full" />
      <div class="h-2.5 bg-gray-300 rounded-full w-full" />
      <div class="h-2.5 bg-gray-300 rounded-full w-24" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[400px]">
      <div class="h-2.5 bg-gray-300 rounded-full w-full" />
      <div class="h-2.5 bg-gray-200 rounded-full w-80" />
      <div class="h-2.5 bg-gray-300 rounded-full w-full" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[480px]">
      <div class="h-2.5 bg-gray-200 rounded-full w-full" />
      <div class="h-2.5 bg-gray-300 rounded-full w-full" />
      <div class="h-2.5 bg-gray-300 rounded-full w-24" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[440px]">
      <div class="h-2.5 bg-gray-300 rounded-full w-32" />
      <div class="h-2.5 bg-gray-300 rounded-full w-24" />
      <div class="h-2.5 bg-gray-200 rounded-full w-full" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[360px]">
      <div class="h-2.5 bg-gray-300 rounded-full w-full" />
      <div class="h-2.5 bg-gray-200 rounded-full w-80" />
      <div class="h-2.5 bg-gray-300 rounded-full w-full" />
    </div>
    <span class="sr-only">Loading...</span>
  </div>

  <div
    v-else
    role="status"
    class="space-y-2.5 animate-pulse max-w-lg">
    <div class="flex items-center w-full space-x-2">
      <div class="h-2.5 bg-gray-700 rounded-full w-32" />
      <div class="h-2.5 bg-gray-600 rounded-full w-24" />
      <div class="h-2.5 bg-gray-600 rounded-full w-full" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[480px]">
      <div class="h-2.5 bg-gray-700 rounded-full w-full" />
      <div class="h-2.5 bg-gray-600 rounded-full w-full" />
      <div class="h-2.5 bg-gray-600 rounded-full w-24" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[400px]">
      <div class="h-2.5 bg-gray-600 rounded-full w-full" />
      <div class="h-2.5 bg-gray-700 rounded-full w-80" />
      <div class="h-2.5 bg-gray-600 rounded-full w-full" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[480px]">
      <div class="h-2.5 bg-gray-700 rounded-full w-full" />
      <div class="h-2.5 bg-gray-600 rounded-full w-full" />
      <div class="h-2.5 bg-gray-600 rounded-full w-24" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[440px]">
      <div class="h-2.5 bg-gray-600 rounded-full w-32" />
      <div class="h-2.5 bg-gray-600 rounded-full w-24" />
      <div class="h-2.5 bg-gray-700 rounded-full w-full" />
    </div>
    <div class="flex items-center w-full space-x-2 max-w-[360px]">
      <div class="h-2.5 bg-gray-600 rounded-full w-full" />
      <div class="h-2.5 bg-gray-700 rounded-full w-80" />
      <div class="h-2.5 bg-gray-600 rounded-full w-full" />
    </div>
  </div>
</template>
